import React from "react";
import { useSite } from "../context/SiteContext";
import { ArticlePage } from "./CavePage";

export default function HezPage() {
  const { c } = useSite();
  return <ArticlePage data={c.hez} />;
}
